import { render, staticRenderFns } from "./WidgetReviewsBoardMobile.vue?vue&type=template&id=5e175dce&scoped=true"
import script from "./WidgetReviewsBoardMobile.vue?vue&type=script&lang=js"
export * from "./WidgetReviewsBoardMobile.vue?vue&type=script&lang=js"
import style0 from "./WidgetReviewsBoardMobile.vue?vue&type=style&index=0&id=5e175dce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e175dce",
  null
  
)

export default component.exports